module.exports = __webpack_public_path__ + "img/karatsu.aef18773.png";